import React from "react";
import {
  Box,
  Button,
  Collapse,
  IconButton,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
} from "@mui/icons-material";
import CircularProgressWithLabel from "./CircularProgressWithLabel";
import DataTable from "./DataTable";

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

const CollapsibleTableRow = ({
  source,
  tableData,
  outerTableFields,
  innerSet,
  innerTableFields,
  logs,
  schedule,
  deleteFunc,
  type,
  setRefresh,
  setOpenRows,
  currentVal,
}) => {
  const classes = useRowStyles();
  const [open, setOpen] = React.useState(currentVal);

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => {
              const newOpen = !open;
              setOpen(newOpen);
              setOpenRows((prevValue) => {
                prevValue[type][tableData["id"]] = newOpen;
                return prevValue;
              });
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        {outerTableFields.map((field, index) => {
          return resolveType(field, index, tableData);
        })}

        {!logs && (
          <TableCell style={{ width: 160 }}>
            <Button
              variant="outlined"
              className="text-danger border-danger border"
              onClick={() => {
                deleteFunc("ABCD12345", source.key, tableData["id"], type);
                setRefresh((prevValue) => !prevValue);
              }}
            >
              {schedule ? "Disable" : "STOP ALL"}
            </Button>
          </TableCell>
        )}
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                All Jobs
              </Typography>
              {logs ? (
                <DataTable
                  source={source}
                  logFields={innerTableFields}
                  tableData={tableData[innerSet]}
                  deleteFunc={deleteFunc}
                  logs={logs}
                />
              ) : (
                <DataTable
                  source={source}
                  tableFields={innerTableFields}
                  tableData={tableData[innerSet].filter(
                    (row) => row["status"] !== "Stp"
                  )}
                  deleteFunc={deleteFunc}
                  type={type}
                  inner
                  logs={logs}
                  schedule={schedule}
                  setRefresh={setRefresh}
                />
              )}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

// Resolving various Types in Table
const resolveType = (value, index, row) => {
  switch (value.type) {
    case "Progress":
      return (
        <TableCell style={{ width: 160 }} key={index}>
          <CircularProgressWithLabel value={row[value.name]} />
        </TableCell>
      );

    case "Label":
      const labelValues = {
        0: {
          className: "warning",
          value: "Currently Executing",
        },
        1: {
          className: "success",
          value: "Completed",
        },
        2: {
          className: "danger",
          value: "Failed",
        },
      };
      return (
        <TableCell
          style={{ width: 160 }}
          key={index}
          className={`text-${labelValues[row[value.name]]["className"]}`}
        >
          {labelValues[row[value.name]]["value"]}
        </TableCell>
      );

    case "TimePeriodObject":
      return (
        <TableCell style={{ width: 160 }} key={index}>
          {value.sections.map((section) => {
            return (
              <>{row["time_period"][section["name"]] + section["id"] + " "}</>
            );
          })}
        </TableCell>
      );

    case "Options":
      let options = "NA";
      if (row[value.name] || value["default"]) {
        options = row[value.options]
          .map((obj) => {
            return obj.name;
          })
          .join();
      }

      return (
        <TableCell style={{ width: 160 }} key={index}>
          {options}
        </TableCell>
      );

    case "SingleOption":
      return (
        <TableCell style={{ width: 160 }} key={index}>
          {row[[value.name]]["name"]}
        </TableCell>
      );

    case "Date":
      return (
        <TableCell style={{ width: 160 }} key={index}>
          {new Date(row[value.name]).toLocaleString()}
        </TableCell>
      );

    //FOR STRING AND ID
    default:
      return (
        <TableCell style={{ width: 160 }} key={index}>
          {row[value.name]}
        </TableCell>
      );
  }
};

export default CollapsibleTableRow;
